export default "__VITE_ASSET__BdbbdR5N__"